import styled from 'styled-components';

export default styled.div`
	--gap: 2rem;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	grid-template-rows: min-content min-content min-content;
	flex: 1;
	gap: var(--gap);
	padding: var(--gap) 0;

	.full {
		display: flex;
		grid-column-end: span 4;
	}
`;
